var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{
        'TRC-ActionButton': 1,
        'TRC-ActionButton--disabled': _vm.disabled,
        'TRC-ActionButton--outline': _vm.outline,
    },style:(_vm.getActionButtonStyle),on:{"click":_vm.onClick}},[(_vm.isProcessing)?[_c('app-spinner',{attrs:{"size":"small"}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }